const esc: { [a: string]: string } = {
	lt: '<',
	gt: '>',
	quot: '"',
	apos: "'",
	amp: '&'
};

const reversedEscapeChars: { [a: string]: string } = (
	 function ()
	 {
		 let obj: { [a: string]: string } = {};
		 for (let key in esc)
		 {
			 obj[esc[key]] = key;
		 }
		 return obj;
	 }
)();

export function escapeHTML(str: string): string
{
	if (!str || typeof str !== 'string')
		return str;
	return str.replace(/[&<>"']/g, m => '&' + reversedEscapeChars[m] + ';');
}
